import { useState, useEffect } from 'react';
import { stripeConnectUrl, stripeStatus } from '../api';

export default function StripeConnect() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [connecting, setConnecting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    stripeStatus()
      .then(setStatus)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const handleConnect = async () => {
    setConnecting(true);
    try {
      const res = await stripeConnectUrl();
      window.location.href = res.url;
    } catch (err) {
      setError(err.message);
      setConnecting(false);
    }
  };

  if (loading) return <p style={{ color: 'var(--muted)', fontSize: 14 }}>Checking payment status…</p>;

  return (
    <div style={{ border: '1.5px solid var(--border)', borderRadius: 10, padding: 20, marginTop: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
            💳 Payment Processing
            {status?.connected && (
              <span style={{ background: 'rgba(16,185,129,0.15)', color: 'var(--green)', fontSize: 11, padding: '2px 8px', borderRadius: 20, fontWeight: 700 }}>
                ✓ Active
              </span>
            )}
            {!status?.connected && (
              <span style={{ background: 'rgba(245,158,11,0.15)', color: 'var(--yellow)', fontSize: 11, padding: '2px 8px', borderRadius: 20, fontWeight: 700 }}>
                Not Connected
              </span>
            )}
          </div>
          <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 3 }}>
            {status?.connected
              ? 'Parents can pay directly in the app. Funds go to your Stripe account.'
              : 'Connect your bank account to accept card payments from parents.'}
          </div>
        </div>
      </div>

      {error && <div className="alert alert-error" style={{ marginBottom: 12 }}>{error}</div>}

      {!status?.connected ? (
        <button className="btn btn-primary" onClick={handleConnect} disabled={connecting}>
          {connecting ? 'Redirecting to Stripe…' : '🔗 Connect Bank Account'}
        </button>
      ) : (
        <div>
          <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 8 }}>
            Payouts: {status.payoutsEnabled ? '✓ Enabled' : '⏳ Pending'}
          </div>
          <button className="btn btn-ghost btn-sm" onClick={handleConnect}>
            Manage Stripe Account ↗
          </button>
        </div>
      )}
    </div>
  );
}
